import { Component, OnInit } from '@angular/core';
import { environment } from '@portals/environments';
import { AuthState } from '@portals/store';

@Component({
	selector: 'portals-error404',
	templateUrl: './error404.component.html',
	styleUrls: ['./error404.component.scss'],
})
export class Error404Component implements OnInit {
	app = environment.app;
	admin: boolean = false;
	constructor(private authState: AuthState) {
		this.admin = ['super_admin', 'aclu_admin'].includes(this.authState.data.role.type);
	}

	ngOnInit(): void {}
}
